import styled from "@emotion/native"
import { TextInputProps } from "react-native"
import MagnifyingGlassIcon from "../../assets/magnifying-glass-icon.svg"
import ClearIcon from "../../assets/v2/Clear.svg"

type CountryPickerSearchProps = TextInputProps

export function CountryPickerSearch({ value, onChangeText, ...rest }: CountryPickerSearchProps) {
  return (
    <FieldWrapper>
      <IconSlot>
        <MagnifyingGlassIcon width={18} height={18} />
      </IconSlot>
      <SearchInput
        value={value}
        onChangeText={onChangeText}
        placeholderTextColor="rgba(31, 28, 34, 0.45)"
        maxFontSizeMultiplier={1.5}
        {...rest}
      />
      {!!value && (
        <ClearButton
          accessibilityRole="button"
          accessibilityLabel="Clear search"
          onPress={() => onChangeText?.("")}
        >
          <ClearIcon width={16} height={16} />
        </ClearButton>
      )}
    </FieldWrapper>
  )
}

const FieldWrapper = styled.View`
  position: relative;
  width: 100%;
`

const IconSlot = styled.View`
  position: absolute;
  left: 14px;
  top: 14px;
  z-index: 1;
  opacity: 0.55;
`

const SearchInput = styled.TextInput`
  width: 100%;
  height: 48px;
  padding: 0 44px;
  font-size: 17px;
  color: ${({ theme }) => theme.text.tertiary4};
  background-color: ${({ theme }) => theme.button.secondary.backgroundColor};
  border-width: 1px;
  border-color: ${({ theme }) => theme.phoneNumberInput.countryCodeSeparatorBorderColor};
  border-radius: 14px;
`

const ClearButton = styled.Pressable`
  position: absolute;
  right: 12px;
  top: 14px;
  z-index: 1;
  opacity: 0.6;
`
